import { render } from "./ZapiBadgePill.vue?vue&type=template&id=de6acd64&scoped=true"
import script from "./ZapiBadgePill.vue?vue&type=script&lang=js"
export * from "./ZapiBadgePill.vue?vue&type=script&lang=js"

import "./ZapiBadgePill.vue?vue&type=style&index=0&id=de6acd64&scoped=true&lang=css"

import exportComponent from "C:\\laragon\\www\\frontend_zapi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de6acd64"]])

export default __exports__